// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.zcp-container{position:static;margin:0px;background-color:transparent;border:none;z-index:0}div.zcp-flex-row{justify-content:start}div.zcp-swatch-area{width:223px;height:146px;margin-top:24px}div.zcp-rgb-a{width:16px;margin:0 10px 0 0;padding:0}", ""]);
// Exports
module.exports = exports;
